export default "__VITE_ASSET__dSMVgfQF__"